"use client";
import Image from "next/image";
import Link from "next/link";
import { useState, useEffect, useRef } from "react";
import styles from "@/app/styles/home.module.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import https from "https";
import Loading from "./loading";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import useDeviceType from "@/app/utils/useDeviceType";
import TruncatedText from "@/app/components/read-more";
import InstagramFeed from "@/app/components/instagram";
import { Carousel } from "react-bootstrap";
import { formatEventDate } from "@/app/utils/formatDate";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import CodeDisplay from "@/app/utils/content";

gsap.registerPlugin(ScrollTrigger);

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getsinHome() {
  const query = `
{
  sinHome: pageBy(id: "cG9zdDoxMDc=") {
    sinHome {
      bannerType
      bannerVideo {
        node {
          mediaItemUrl
        }
      }
      bannerMobileVideo {
        node {
          mediaItemUrl
        }
      }
      bannerSliders {
        bannerImage1920X1080 {
          node {
            mediaItemUrl
          }
        }
      }
      disableEventsAndOffers
      disableInstagramFeed
      disabledFeaturedPoints
      disabledLineUp
      disabledMenu
      eventsAndOffersTitle
      featuredPoints {
        description
        title
        image {
          node {
            mediaItemUrl
          }
        }
      }
      featuredPointsDesktopVideo {
        node {
          mediaItemUrl
        }
      }
      featuredPointsMobileVideo {
        node {
          mediaItemUrl
        }
      }
      featuredTitle
      gallery {
        mediaType
        image {
          node {
            mediaItemUrl
          }
        }
        video {
          node {
            mediaItemUrl
          }
        }
        videoThumbnail {
          node {
            mediaItemUrl
          }
        }
        embedVideo
        videoType
      }
      instagramProfileName
      instagramTitle
      instagramUrl
      lineUpTitle
      menuList {
        mediaType
        title
        image {
          node {
            mediaItemUrl
          }
        }
        menuPdf {
          node {
            mediaItemUrl
          }
        }
        video {
          node {
            mediaItemUrl
          }
        }
      }
      menuTitle
      welcomeSectionDescription
      welcomeSectionMainImage {
        node {
          mediaItemUrl
        }
      }
      welcomeSectionSubImage {
        node {
          mediaItemUrl
        }
      }
      welcomeSectionTitle
      upcomingOffers {
        eventAndOffer {
          nodes {
            id
            ... on Qleventoffer {
              id
              eventsOffers {
                endDate
                startDate
                customizeDateText
                featureImage {
                  node {
                    mediaItemUrl
                  }
                }
                description
              }
              title
              slug
              status
              taxoffers {
                nodes {
                  name
                }
              }
            }
          }
        }
      }
      performanceObject {
        homePerformance {
          nodes {
            ... on Qlperformer {
              id
              performers {
                performerCountry
                performerDescription
                performerImage {
                  node {
                    mediaItemUrl
                  }
                }
                upcomingPerformance {
                  performanceDate
                  performanceTime
                }
              }
              title
              content
              slug
              uri
            }
          }
        }
      }
    }
  }
}
  `;

  const res = await fetch(`${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`, {
    httpsAgent: agent,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query }),
    next: {
      revalidate: 60,
    },
  });

  const { data } = await res.json();

  return data;
}

export default function Home() {
  const deviceType = useDeviceType();

  // const elementsRef = useRef([]);
  // elementsRef.current = [];

  const [sinHome, setsinHome] = useState(null);

  const [banner_type, setBannerType] = useState("");
  const [banner_video, setBannerVideo] = useState("");
  const [banner_video_mobile, setBannerVideoMobile] = useState("");
  const [banner_images, setBannerImage] = useState([]);

  const [overview_main_img, setOverviewMainImage] = useState("");
  const [overview_sub_img, setOverviewSubImage] = useState("");
  const [overview_title, setOverviewTitle] = useState("");
  const [overview_desc, setOverviewDesc] = useState("");

  const [is_feature_disabled, setIsFeatureDisabled] = useState(false);
  const [feature_title, setFeatureTitle] = useState("");
  const [feature_list, setFeatureList] = useState([]);

  const [is_menu_disabled, setIsMenuDisabled] = useState(false);
  const [menu_title, setMenuTitle] = useState("");
  const [menu_list, setMenuList] = useState([]);

  const [is_performance_disabled, setIsPerformanceDisabled] = useState(false);
  const [performance_title, setPerformanceTitle] = useState("");
  const [performance_list, setPerformers] = useState([]);

  const [is_offer_disabled, setIsOfferDisabled] = useState(false);
  const [offer_title, setOfferTitle] = useState("");
  const [offer_list, setOfferList] = useState([]);

  const [is_insta_disabled, setIsInstaDisabled] = useState(false);
  const [insta_title, setInstaTitle] = useState("");
  const [insta_profile, setInstaProfile] = useState("");
  const [insta_url, setInstaUrl] = useState("");
  const [insta_list, setInstaList] = useState([]);

  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  const [navper1, setPerNav1] = useState();
  const [navper2, setPerNav2] = useState();

  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const openVideoModal = (url) => {
    setVideoUrl(url);
    setShowVideoModal(true);
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
  };

  const wrapperRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const page = await getsinHome();
      if (page) {
        setsinHome(page);
        if (page.sinHome && page.sinHome.sinHome) {
          if (page.sinHome.sinHome.bannerType) {
            if (page.sinHome.sinHome.bannerType[0]) {
              setBannerType(page.sinHome.sinHome.bannerType[0]);
            }
          }
          /// console.log('type:',page.sinHome.sinHome.bannerType);
          if (page.sinHome.sinHome.bannerSliders) {
            setBannerImage(page.sinHome.sinHome.bannerSliders);
          }
          //console.log(page.sinHome.sinHome.bannerSliders);
          if (
            page.sinHome.sinHome.bannerVideo &&
            page.sinHome.sinHome.bannerVideo.node &&
            page.sinHome.sinHome.bannerVideo.node.mediaItemUrl
          ) {
            setBannerVideo(page.sinHome.sinHome.bannerVideo.node.mediaItemUrl);
          }

          if (
            page.sinHome.sinHome.bannerMobileVideo &&
            page.sinHome.sinHome.bannerMobileVideo.node &&
            page.sinHome.sinHome.bannerMobileVideo.node.mediaItemUrl
          ) {
            setBannerVideoMobile(
              page.sinHome.sinHome.bannerMobileVideo.node.mediaItemUrl,
            );
          }

          if (page.sinHome.sinHome.welcomeSectionTitle) {
            setOverviewTitle(page.sinHome.sinHome.welcomeSectionTitle);
          }
          if (page.sinHome.sinHome.welcomeSectionDescription) {
            setOverviewDesc(page.sinHome.sinHome.welcomeSectionDescription);
          }
          if (page.sinHome.sinHome.welcomeSectionMainImage) {
            if (page.sinHome.sinHome.welcomeSectionMainImage.node) {
              if (
                page.sinHome.sinHome.welcomeSectionMainImage.node.mediaItemUrl
              ) {
                setOverviewMainImage(
                  page.sinHome.sinHome.welcomeSectionMainImage.node
                    .mediaItemUrl,
                );
              }
            }
          }
          if (page.sinHome.sinHome.welcomeSectionSubImage) {
            if (page.sinHome.sinHome.welcomeSectionSubImage.node) {
              if (
                page.sinHome.sinHome.welcomeSectionSubImage.node.mediaItemUrl
              ) {
                setOverviewSubImage(
                  page.sinHome.sinHome.welcomeSectionSubImage.node.mediaItemUrl,
                );
              }
            }
          }

          if (page.sinHome.sinHome.disabledFeaturedPoints) {
            setIsFeatureDisabled(page.sinHome.sinHome.disabledFeaturedPoints);
          }
          if (page.sinHome.sinHome.featuredTitle) {
            setFeatureTitle(page.sinHome.sinHome.featuredTitle);
          }
          if (page.sinHome.sinHome.featuredPoints) {
            setFeatureList(page.sinHome.sinHome.featuredPoints);
          }

          if (page.sinHome.sinHome.disabledMenu) {
            setIsMenuDisabled(page.sinHome.sinHome.disabledMenu);
          }
          if (page.sinHome.sinHome.menuTitle) {
            setMenuTitle(page.sinHome.sinHome.menuTitle);
          }
          if (page.sinHome.sinHome.menuList) {
            setMenuList(page.sinHome.sinHome.menuList);
          }

          if (page.sinHome.sinHome.disabledLineUp) {
            setIsPerformanceDisabled(page.sinHome.sinHome.disabledLineUp);
          }
          if (page.sinHome.sinHome.lineUpTitle) {
            setPerformanceTitle(page.sinHome.sinHome.lineUpTitle);
          }

          if (page.sinHome.sinHome.disableEventsAndOffers) {
            setIsOfferDisabled(page.sinHome.sinHome.disableEventsAndOffers);
          }
          if (page.sinHome.sinHome.eventsAndOffersTitle) {
            setOfferTitle(page.sinHome.sinHome.eventsAndOffersTitle);
          }
          if (page.sinHome.sinHome.upcomingOffers) {
            setOfferList(page.sinHome.sinHome.upcomingOffers);
          }

          if (page.sinHome.sinHome.disableInstagramFeed) {
            setIsInstaDisabled(page.sinHome.sinHome.disableInstagramFeed);
          }
          if (page.sinHome.sinHome.instagramTitle) {
            setInstaTitle(page.sinHome.sinHome.instagramTitle);
          }
          if (page.sinHome.sinHome.instagramProfileName) {
            setInstaProfile(page.sinHome.sinHome.instagramProfileName);
          }
          if (page.sinHome.sinHome.instagramUrl) {
            setInstaUrl(page.sinHome.sinHome.instagramUrl);
          }
          if (page.sinHome.sinHome.gallery) {
            setInstaList(page.sinHome.sinHome.gallery);
          }
          if (page.sinHome.sinHome.performanceObject) {
            setPerformers(page.sinHome.sinHome.performanceObject);
          }
        }
      }
    };

    fetchData();
    return () => {};
  }, []);

  // Throttle function
  const throttled = (delay, fn) => {
    let lastCall = 0;
    return function (...args) {
      const now = new Date().getTime();
      if (now - lastCall < delay) {
        return;
      }
      lastCall = now;
      return fn(...args);
    };
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    focusOnSelect: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
    ],
  };

  const settingsoffer = {
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    focusOnSelect: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 5000,
        },
      },
    ],
  };

  const settingsnav = {
    asNavFor: nav1,
    ref: (slider2) => setNav2(slider2),
    slidesToShow: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    infinite: true,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    centerMode: false,
    className: "feature-slider",
    responsive: [
      {
        breakpoint: 1025, // Define the breakpoint for mobile devices
        settings: {
          slidesToShow: 1, // Show only 1 slide on mobile devices
        },
      },
    ],
  };

  const settingsfor = {
    asNavFor: nav2,
    ref: (slider1) => setNav1(slider1),
    arrows: false,
    autoplay: false,
    autoplaySpeed: 5000,
    centerMode: false,
    fade: true,
    className: "settingForSlider",
  };

  useEffect(() => {
    if (!sinHome) return;

    const initializeScroll = async () => {
      const LocomotiveScroll = (await import("locomotive-scroll")).default;
      const locomotiveScroll = new LocomotiveScroll();
    };

    initializeScroll();

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, [sinHome]);

  if (!sinHome) {
    return <Loading />;
  }
  //console.log('banner_type:',banner_type);
  return (
    <>
      {/* <div ref={cursorRef} className="cursor">
        <span ref={textRef} className="piu">
          View Gallery
        </span>
      </div>
      <div ref={followerRef} className="cursor-follower"></div> */}

      <section className={styles.banner_section}>
        {banner_type === "Image" && (
          <div className="inner-banner position-relative">
            {banner_images && banner_images.length !== 0 && (
              <Carousel fade className="page-inner-carousel">
                {banner_images.map((banner_img, index) => {
                  let imgurl = "";

                  if (banner_img.bannerImage1920X1080) {
                    if (banner_img.bannerImage1920X1080.node) {
                      if (banner_img.bannerImage1920X1080.node.mediaItemUrl) {
                        imgurl =
                          banner_img.bannerImage1920X1080.node.mediaItemUrl;
                      }
                    }
                  }

                  return (
                    <Carousel.Item key={index}>
                      <Image
                        className={styles.banner_section_main_img}
                        src={imgurl}
                        width={deviceType !== "mobile" ? 1920 : 400}
                        height={deviceType !== "mobile" ? 1080 : 800}
                        alt="Banner Image"
                        priority
                        quality={deviceType !== "mobile" ? 50 : 80}
                      />
                    </Carousel.Item>
                  );
                })}
              </Carousel>
            )}
          </div>
        )}

        {banner_type === "Video" && (
          <video autoPlay muted loop>
            <source
              src={deviceType !== "mobile" ? banner_video : banner_video_mobile}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        )}
      </section>

      <section className="bg-color--red overflow-hidden bg-layer position-relative section-padding-top section-padding-bottom">
        <div className="main-wrapper z-top section-padding-bottom d-flex flex-wrap justify-content-between">
          <div className={styles.overview_left}>
            <h2
              className={`${styles.overviewH2} section-heading--main mobile_el section-heading--white all-caps heading-padding`}
            >
              {overview_title}
            </h2>
            <Image
              src={overview_main_img}
              width={600}
              height={800}
              alt="white mesh"
            />
          </div>
          <div className={styles.overview_center}>
            <div>
              <h2 className="section-heading--main desktop_el section-heading--white all-caps heading-padding">
                {overview_title}
              </h2>
              <p className="paragraph font-color--light-gray">
                {overview_desc}
              </p>
            </div>
          </div>
          <div className={styles.overview_right}>
            <Image
              src={overview_sub_img}
              width={400}
              height={450}
              alt="white mesh"
            />
          </div>
        </div>
        <div className={`lsmall-wrap z-top ${styles.lsmall_wrap}`}>
          <h2
            className={`section-heading--main section-heading--white all-caps text-center ${styles.overviewH2}`}
          >
            {feature_title}
          </h2>
        </div>
      </section>

      <section
        className={`bg-color--blue overflow-hidden bg-layer section-padding-top position-relative ${styles.feature_sec}`}
      >
        {!is_feature_disabled && (
          <>
            <video className={styles.top_video} autoPlay muted loop>
              <source src="/feature.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="main-wrapper z-top section-padding-bottom">
              <Slider {...settingsnav} className="feature-slider">
                {feature_list &&
                  feature_list.map((item, index) => {
                    let title = "";

                    if (item.title) {
                      title = item.title;
                    }

                    return (
                      <div className="slide-item paragraph--white" key={index}>
                        <h3 className="section-heading-large section-heading--white all-caps text-center">
                          {title}
                        </h3>
                      </div>
                    );
                  })}
              </Slider>
              <Slider {...settingsfor}>
                {feature_list &&
                  feature_list.map((item, index) => {
                    let desc = "";
                    let img = "";

                    if (item.description) {
                      desc = item.description;
                    }
                    if (item.image) {
                      if (item.image.node) {
                        if (item.image.node.mediaItemUrl) {
                          img = item.image.node.mediaItemUrl;
                        }
                      }
                    }

                    return (
                      <div className="slide-item" key={index}>
                        <div className={styles.feature_slider}>
                          <div className={styles.feature_slider_inner}>
                            <Image
                              src={img}
                              width={600}
                              height={800}
                              alt="white mesh"
                            />
                            <p className="paragraph font-color--light-gray xsmall-padding-top">
                              {desc}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </Slider>
            </div>
          </>
        )}
        {!is_menu_disabled && (
          <>
            <div className="main-wrapper z-top d-flex align-items-end justify-content-between">
              <div className={`${styles.title_left} ${styles.lsmall_wrap}`}>
                <h2
                  className={`${styles.overviewH2} section-heading--main section-heading--white all-caps m-0`}
                >
                  {menu_title}
                </h2>
              </div>
              <div className={`${styles.link_right} desktop_el`}>
                <Link href={"/wine-dine"} className="next-btn next-btn--white">
                  view all menus
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="18"
                    viewBox="0 0 11 18"
                    fill="none"
                  >
                    <path
                      d="M1 1L9 9.00018L1 17"
                      stroke="white"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
            </div>
            <div className="main-wrapper z-top small-padding-top section-padding-bottom overflow-hidden">
              <Slider
                {...settings}
                className={`${styles.food_slider} food_slider`}
              >
                {menu_list &&
                  menu_list.map((item, index) => {
                    let type = "";
                    let title = "";
                    let img = "";
                    let video = "";
                    let menu = "";

                    if (item.mediaType) {
                      if (item.mediaType[0]) {
                        type = item.mediaType[0];
                      }
                    }
                    if (item.title) {
                      title = item.title;
                    }
                    if (item.menuPdf) {
                      if (item.menuPdf.node) {
                        if (item.menuPdf.node.mediaItemUrl) {
                          menu = item.menuPdf.node.mediaItemUrl;
                        }
                      }
                    }
                    if (type === "Image") {
                      if (item.image) {
                        if (item.image.node) {
                          if (item.image.node.mediaItemUrl) {
                            img = item.image.node.mediaItemUrl;
                          }
                        }
                      }
                    } else {
                      if (item.video) {
                        if (item.video.node) {
                          if (item.video.node.mediaItemUrl) {
                            video = item.video.node.mediaItemUrl;
                          }
                        }
                      }
                    }

                    return (
                      <div className="slide-item" key={index}>
                        <Link
                          target="_blank"
                          href={menu}
                          className={styles.food_box}
                        >
                          {type === "Image" && (
                            <Image
                              src={img}
                              width={560}
                              height={680}
                              alt="white mesh"
                              className={styles.food_box_img}
                            />
                          )}
                          {type !== "Image" && (
                            <video
                              className={styles.food_box_img}
                              autoPlay
                              muted
                              loop
                            >
                              <source src={video} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          )}
                          <div className={styles.food_box_content}>
                            <h6 className="sub-heading sub-heading--white all-caps">
                              {title}
                            </h6>
                            <div className="d-flex flex-column align-items-center justify-content-center download-btn">
                              {menu && (
                                <a
                                  target="_blank"
                                  className={`${styles.download_menu} next-btn next-btn--yellow flex-column`}
                                  href={menu}
                                >
                                  <p className="next-btn next-btn--white">
                                    download menu
                                  </p>
                                  <Image
                                    src="/down-arr-w.png"
                                    width={20}
                                    height={20}
                                    alt="Banner Image"
                                  />
                                </a>
                              )}
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  })}
              </Slider>
              <div
                className={`${styles.link_right} mobile_el_flex small-padding-top`}
              >
                <Link href={"/"} className="next-btn next-btn--white">
                  view all menus
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="18"
                    viewBox="0 0 11 18"
                    fill="none"
                  >
                    <path
                      d="M1 1L9 9.00018L1 17"
                      stroke="white"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </>
        )}
        {!is_performance_disabled && (
          <div className="main-wrapper z-top d-flex flex-wrap align-items-end justify-content-between small-padding-bottom">
            <div className={styles.link_right}></div>
            <div className={styles.title_center}>
              <h2 className="section-heading--main section-heading--white all-caps m-0 text-center">
                {performance_title}
              </h2>
            </div>
            <div className={`${styles.link_right} desktop_el`}>
              <Link href={"performers"} className="next-btn next-btn--white">
                view all performers
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="18"
                  viewBox="0 0 11 18"
                  fill="none"
                >
                  <path
                    d="M1 1L9 9.00018L1 17"
                    stroke="white"
                    strokeWidth="2"
                  />
                </svg>
              </Link>
            </div>
          </div>
        )}
      </section>

      {!is_performance_disabled && (
        <section className="position-relative">
          <div className={`d-flex flex-wrap z-top ${styles.per_wrap}`}>
            <div className={`${styles.performance_left} bg-color--red`}>
              <Slider {...settingsnav} className="performance-slider">
                {performance_list.map((eventPerform, index) => {
                  let title = "";
                  let slug = "";
                  let slugcontent = "";
                  let performerCountry = "";
                  let desc = "";
                  let type = [];
                  let performerdateTime = [];

                  //console.log(eventPerform);

                  if (eventPerform.homePerformance) {
                    if (eventPerform.homePerformance.nodes) {
                      if (eventPerform.homePerformance.nodes[0]) {
                        if (eventPerform.homePerformance.nodes[0].title) {
                          title = eventPerform.homePerformance.nodes[0].title;
                        }
                        if (eventPerform.homePerformance.nodes[0].slug) {
                          slug = eventPerform.homePerformance.nodes[0].slug;
                        }
                        if (eventPerform.homePerformance.nodes[0].content) {
                          slugcontent =
                            eventPerform.homePerformance.nodes[0].content;
                        }

                        if (eventPerform.homePerformance.nodes[0].performers) {
                          if (
                            eventPerform.homePerformance.nodes[0].performers
                              .performerCountry
                          ) {
                            performerCountry =
                              eventPerform.homePerformance.nodes[0].performers
                                .performerCountry;
                          }
                          if (
                            eventPerform.homePerformance.nodes[0].performers
                              .performerDescription
                          ) {
                            desc =
                              eventPerform.homePerformance.nodes[0].performers
                                .performerDescription;
                          }
                          if (
                            eventPerform.homePerformance &&
                            eventPerform.homePerformance.nodes &&
                            eventPerform.homePerformance.nodes[0]
                          ) {
                            const performers =
                              eventPerform.homePerformance.nodes[0].performers;
                            if (performers && performers.upcomingPerformance) {
                              performerdateTime =
                                performers.upcomingPerformance;
                            }
                          }
                        }
                      }
                    }
                  }

                  const truncatedTitle =
                    title.length > 150
                      ? `${title.substring(0, 150)}[...]`
                      : title;

                  const truncatedDesc =
                    desc.length > 150 ? `${desc.substring(0, 150)}[...]` : desc;

                  return (
                    <div className="slide-item" key={index}>
                      <div className={styles.performance_details}>
                        <div className="d-flex flex-wrap align-items-end heading-padding mobile-justify-center">
                          <h6 className="sub-heading sub-heading--white all-caps m-0">
                            {title}
                          </h6>
                          {performerCountry && (
                            <h5 className="paragraph paragraph--white all-caps font-family-cocormorant m-0">
                              / {performerCountry}
                            </h5>
                          )}
                        </div>
                        <p className="paragraph paragraph--white m-0">
                          {truncatedDesc}
                        </p>
                        <div className="line-w"></div>
                        <p className="paragraph font-color--light-gray m-0">
                          {slugcontent}
                        </p>
                        <h5 className="sub-heading-small sub-heading--white all-caps m-0 heading-padding small-padding-top mobile-text-center">
                          upcoming performances
                        </h5>
                        <div className="d-flex flex-wrap xsmall-padding-bottom performdatesT">
                          {performerdateTime.length > 0 ? (
                            performerdateTime
                              .slice(0, 2)
                              .map((performance, indexin) => {
                                let performanceDate =
                                  performance.performanceDate || "";
                                let performanceTime =
                                  performance.performanceTime || "";

                                const eventDateText =
                                  formatEventDate(performanceDate);
                                return (
                                  <div
                                    className={styles.performance_details_left}
                                    key={indexin}
                                  >
                                    <Image
                                      src="/calender.png"
                                      width={30}
                                      height={30}
                                      alt="Banner Image"
                                    />
                                    <div>
                                      <div className="paragraph font-color--light-gray m-0 all-caps">
                                        {performanceDate}
                                      </div>
                                      <div className="paragraph font-color--light-gray all-caps m-0">
                                        {performanceTime}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <p>No upcoming performances available.</p>
                          )}
                        </div>
                        <Link
                          href={`/sin-performer/${slug}`}
                          className="next-btn next-btn--white mobile-justify-center"
                        >
                          view profile
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="11"
                            height="18"
                            viewBox="0 0 11 18"
                            fill="none"
                          >
                            <path
                              d="M1 1L9 9.00018L1 17"
                              stroke="white"
                              strokeWidth="2"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </Slider>
              <div
                className={`${styles.link_right} mobile_el small-padding-bottom`}
              >
                <Link href={"performers"} className="next-btn next-btn--white">
                  view all performers
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="18"
                    viewBox="0 0 11 18"
                    fill="none"
                  >
                    <path
                      d="M1 1L9 9.00018L1 17"
                      stroke="white"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
            </div>
            <div className={styles.performance_right}>
              <Slider {...settingsfor}>
                {performance_list.map((eventPerform, indexm) => {
                  let performerImage = "";

                  //  console.log(eventPerform);

                  if (eventPerform.homePerformance) {
                    if (eventPerform.homePerformance.nodes) {
                      if (eventPerform.homePerformance.nodes[0]) {
                        if (eventPerform.homePerformance.nodes[0].performers) {
                          if (
                            eventPerform.homePerformance.nodes[0].performers
                              .performerImage
                          ) {
                            if (
                              eventPerform.homePerformance.nodes[0].performers
                                .performerImage.node
                            ) {
                              if (
                                eventPerform.homePerformance.nodes[0].performers
                                  .performerImage.node.mediaItemUrl
                              ) {
                                performerImage =
                                  eventPerform.homePerformance.nodes[0]
                                    .performers.performerImage.node
                                    .mediaItemUrl;
                              }
                            }
                          }
                        }
                      }
                    }
                  }

                  return (
                    <div className="slide-item" key={indexm}>
                      <Image
                        src={performerImage}
                        width={830}
                        height={830}
                        alt="Banner Image"
                      />
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </section>
      )}

      {!is_offer_disabled && (
        <section className="section-padding-bottom overflow-hidden section-padding-top bg-layer bg-color--blue position-relative">
          <div className="main-wrapper z-top d-flex align-items-end justify-content-between">
            <div className={styles.title_left}>
              <h2 className="section-heading--main section-heading--white all-caps m-0">
                {offer_title}
              </h2>
            </div>
            <div className={`${styles.link_right} desktop_el`}>
              <Link href={"events-offers"} className="next-btn next-btn--white">
                view all events & offers
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="18"
                  viewBox="0 0 11 18"
                  fill="none"
                >
                  <path
                    d="M1 1L9 9.00018L1 17"
                    stroke="white"
                    strokeWidth="2"
                  />
                </svg>
              </Link>
            </div>
          </div>
          <div className="main-wrapper z-top small-padding-top">
            <Slider
              {...settingsoffer}
              className={`${styles.offer_slider} offer_slider`}
            >
              {offer_list.map((event, indexl) => {
                let title = "";
                let slug = "";
                let imgurl = "";
                let start_date = "";
                let end_date = "";
                let desc = "";
                let custom_date = "";
                let type = [];
                let status = "";

                //console.log(event);

                if (event.eventAndOffer) {
                  if (event.eventAndOffer.nodes) {
                    if (event.eventAndOffer.nodes[0]) {
                      if (event.eventAndOffer.nodes[0].title) {
                        title = event.eventAndOffer.nodes[0].title;
                      }
                      if (event.eventAndOffer.nodes[0].status) {
                        status = event.eventAndOffer.nodes[0].status;
                      }
                    }
                    if (event.eventAndOffer.nodes[0].slug) {
                      slug = event.eventAndOffer.nodes[0].slug;
                    }
                    if (event.eventAndOffer.nodes[0].taxoffers) {
                      if (event.eventAndOffer.nodes[0].taxoffers.nodes) {
                        type = event.eventAndOffer.nodes[0].taxoffers.nodes;
                      }
                    }
                    if (event.eventAndOffer.nodes[0].eventsOffers) {
                      if (event.eventAndOffer.nodes[0].eventsOffers.startDate) {
                        start_date =
                          event.eventAndOffer.nodes[0].eventsOffers.startDate;
                      }
                      if (
                        event.eventAndOffer.nodes[0].eventsOffers
                          .customizeDateText
                      ) {
                        custom_date =
                          event.eventAndOffer.nodes[0].eventsOffers
                            .customizeDateText;
                      }
                      if (
                        event.eventAndOffer.nodes[0].eventsOffers.description
                      ) {
                        desc =
                          event.eventAndOffer.nodes[0].eventsOffers.description;

                        if (event.eventAndOffer.nodes[0].eventsOffers.endDate) {
                          end_date =
                            event.eventAndOffer.nodes[0].eventsOffers.endDate;
                        }
                        if (
                          event.eventAndOffer.nodes[0].eventsOffers.featureImage
                        ) {
                          if (
                            event.eventAndOffer.nodes[0].eventsOffers
                              .featureImage.node
                          ) {
                            if (
                              event.eventAndOffer.nodes[0].eventsOffers
                                .featureImage.node.mediaItemUrl
                            ) {
                              imgurl =
                                event.eventAndOffer.nodes[0].eventsOffers
                                  .featureImage.node.mediaItemUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
                //console.log(type);

                const truncatedTitle =
                  title.length > 150
                    ? `${title.substring(0, 150)}[...]`
                    : title;

                const truncatedDesc =
                  desc.length > 150 ? `${desc.substring(0, 150)}[...]` : desc;

                const eventDateText = formatEventDate(
                  start_date,
                  end_date,
                  custom_date,
                );

                if (status == "publish") {
                  return (
                    <div className="slide-item" key={indexl}>
                      <Link
                        href={`/events-and-offers/${slug}`}
                        className={styles.offer_box}
                      >
                        <div className={styles.offer_box_img}>
                          <Image
                            src={imgurl}
                            width={350}
                            height={450}
                            alt="Banner Image"
                          />
                          {type &&
                            type.map((tag, indexi) => {
                              return (
                                <div
                                  className={styles.offer_box_right_tag}
                                  key={indexi}
                                >
                                  {tag.name}
                                </div>
                              );
                            })}
                        </div>
                        <div className={styles.offer_box_content}>
                          <div>
                            <p className="paragraph-small paragraph--white">
                              {eventDateText}
                            </p>
                            <h6 className="sub-heading sub-heading--white heading-padding all-caps">
                              {truncatedTitle}
                            </h6>
                            <p className="paragraph font-color--light-gray heading-padding">
                              {truncatedDesc}
                            </p>
                            <div className="next-btn next-btn--white mobile-justify-center">
                              more details
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="11"
                                height="18"
                                viewBox="0 0 11 18"
                                fill="none"
                              >
                                <path
                                  d="M1 1L9 9.00018L1 17"
                                  stroke="white"
                                  strokeWidth="2"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                }
              })}
            </Slider>
            <div className={`${styles.link_right} mobile_el small-padding-top`}>
              <Link href={"events-offers"} className="next-btn next-btn--white">
                view all events & offers
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="18"
                  viewBox="0 0 11 18"
                  fill="none"
                >
                  <path
                    d="M1 1L9 9.00018L1 17"
                    stroke="white"
                    strokeWidth="2"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </section>
      )}

      {!is_insta_disabled && (
        <section className="section-padding-bottom overflow-hidden section-padding-top bg-layer bg-color--red position-relative">
          <div className="lsmall-wrap z-top text-center small-padding-bottom">
            <h2 className="section-heading--main section-heading--white all-caps m-0 text-center heading-padding p-b-i-60">
              {insta_title}
            </h2>
            <a
              target="_blank"
              href={insta_url}
              className="sub-heading-small font-color--light-gray insta-link text-center"
            >
              {insta_profile}
            </a>
          </div>
          <div className="main-wrapper z-top">
            <div className="home-gallery">
              {insta_list.map((item, indexq) => {
                let type = "";
                let img = "";
                let video_type = "";
                let video_url = "";
                let video_emb = "";
                let video_img = "";

                if (item.mediaType) {
                  if (item.mediaType[0]) {
                    type = item.mediaType[0];
                  }
                }
                if (type === "Image") {
                  if (item.image) {
                    if (item.image.node) {
                      if (item.image.node.mediaItemUrl) {
                        img = item.image.node.mediaItemUrl;
                      }
                    }
                  }
                } else {
                  if (item.videoType) {
                    if (item.videoType[0]) {
                      video_type = item.videoType[0];
                    }
                  }

                  if (item.videoThumbnail) {
                    if (item.videoThumbnail.node) {
                      if (item.videoThumbnail.node.mediaItemUrl) {
                        video_img = item.videoThumbnail.node.mediaItemUrl;
                      }
                    }
                  }

                  if (video_type === "File") {
                    if (item.video) {
                      if (item.video.node) {
                        if (item.video.node.mediaItemUrl) {
                          video_url = item.video.node.mediaItemUrl;
                        }
                      }
                    }
                  } else {
                    if (item.embedVideo) {
                      video_emb = item.embedVideo;
                    }
                  }
                }

                return (
                  <>
                    <div className={`div${indexq + 1}`} key={indexq}>
                      {type === "Image" && (
                        <Link target="_blank" href={insta_url}>
                          <Image
                            src={img}
                            width={560}
                            height={680}
                            alt="white mesh"
                            className={styles.food_box_img}
                          />
                        </Link>
                      )}
                      {type !== "Image" && (
                        <div className="video-box video-box-home w-100 h-100">
                          <div
                            className="video-box-inner w-100 h-100"
                            onClick={() => openVideoModal(video_url)}
                          >
                            <Link target="_blank" href={insta_url}>
                              <Image
                                height={500}
                                width={500}
                                src={video_img}
                                alt="Previous"
                              />
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                    {type !== "Image" && (
                      <Modal
                        show={showVideoModal}
                        onHide={closeVideoModal}
                        className="gallery-box"
                        centered
                      >
                        <Modal.Header closeButton></Modal.Header>
                        <Modal.Body>
                          <div className="modal-content modal-lightbox home-modal iframe-div">
                            {video_type !== "File" && (
                              <CodeDisplay code={video_emb} />
                            )}
                            {video_type === "File" && (
                              <video
                                className={styles.food_box_img}
                                autoPlay
                                muted
                                loop
                              >
                                <source src={video_url} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            )}
                          </div>
                        </Modal.Body>
                      </Modal>
                    )}
                  </>
                );
              })}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
